import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
}

export function CustomPhoneInput({
  value,
  onChange,
  placeholder = "Enter phone number",
  error,
  required = false,
}: PhoneInputProps) {
  return (
    <>
      <PhoneInput
        international
        countryCallingCodeEditable={false}
        defaultCountry="FR"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="PhoneInput" // relies on your Tailwind styling for internal parts
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </>
  );
}
